import ApiService from '@/services/api.service'

const TarsService = {
    getAllListing(parameter){
        const params = {      
            DateTimeFrom : parameter.DateTimeFrom,
            DateTimeTo : parameter.DateTimeTo,
            ProgramList : parameter.ProgramList,
            BuildingList : parameter.BuildingList,
            LevelList : parameter.LevelList,
            RoomList : parameter.RoomList,
            PatientList : parameter.PatientList, 
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,          
            PageNumber : parameter.PageNumber,            
        }
        return ApiService.getWithArray('/PatientTars/Patients/',params); 
    },

    getOrderListing(parameter){      
        const params = { 
            PatientCode : parameter.PatientCode,
            DateTimeFrom : parameter.DateFrom,
            DateTimeTo : parameter.DateTo,
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            Mode:parameter.Mode,
            PageNumber : parameter.PageNumber,     
            Status: parameter.Status       
        }
        return ApiService.getWithArray('/PatientTars/OrdersTars/',params); 
    },

    add(data){
        return ApiService.post(`/PatientTars`,data)
    },

    delete(id){
        return ApiService.delete(`/PatientTars/${id}`)
    },
    
    update(id,data){
        return ApiService.put(`/PatientTars/${id}`,data)
    },
}

export default TarsService;